import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  CreateUpdateVisitRegistrationDto,
  CreateUpdateVisitRegistrationDtoFromJSON,
  GetLastEditorDto,
  GetVisitRegistrationDto,
} from '../autogenerated/spdApiClient';
import { validateAgainst } from '../validation/validateAgainst';
import { VisitRegistrationSchema } from '../validation/schemas';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { visitForGrid } from '../../../spd/components/VisitsRegistrations/VisitRegistrationSearch';

export interface VisitRegistrationContextInterface {
  get: (id: string) => Promise<GetVisitRegistrationDto>;
  getAll: (
    healthcareId?: string,
    dateStart?: Date,
    dateEnd?: Date,
  ) => Promise<GetVisitRegistrationDto[]>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
  create: (
    dto: CreateUpdateVisitRegistrationDto,
  ) => Promise<GetVisitRegistrationDto>;
  update: (id: string, dto: CreateUpdateVisitRegistrationDto) => Promise<void>;
  changeToInactive: (id: string) => Promise<void>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const VisitRegistrationContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.visitRegistrationControllerGet(id);
    },

    getAll: (healthcareId?: string, dateStart?: Date, dateEnd?: Date) =>
      api.visitRegistrationControllerGetAll(healthcareId, dateStart, dateEnd),

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      filterColumns?: string,
    ) => {
      const data = await api.visitRegistrationControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        filterColumns || '',
      );
      return data.map(visitForGrid);
    },

    getAllCount: (filterText?: string, filterColumns?: string) =>
      api.visitRegistrationControllerGetAllCount(
        filterText || '',
        filterColumns || '',
      ),

    create: (dto: CreateUpdateVisitRegistrationDto) =>
      api.visitRegistrationControllerCreate(dto),

    update: (id: string, dto: CreateUpdateVisitRegistrationDto) =>
      api.visitRegistrationControllerUpdate(id, dto),

    changeToInactive: (id: string) =>
      api.visitRegistrationControllerChangeToInactive(id),

    getLastEditor: (id: string) =>
      api.visitRegistrationControllerGetLastEditor(id),
  };
};

export const newVisit = (startTime?: Date, endTime?: Date) => {
  const converted = CreateUpdateVisitRegistrationDtoFromJSON({});

  converted.visitDateTime = startTime;
  converted.visitTime =
    endTime && startTime
      ? (endTime.getTime() - startTime.getTime()) / (1000 * 60)
      : null;
  return converted;
};

export const validate = (visit: CreateUpdateVisitRegistrationDto) =>
  validateAgainst(VisitRegistrationSchema, visit);

export const convert = (visit?: GetVisitRegistrationDto) => {
  if (!visit) {
    return newVisit();
  }
  const converted = CreateUpdateVisitRegistrationDtoFromJSON(visit);
  converted.examTypeId = visit?.examType?.id;
  converted.examId = visit?.exam?.id;
  converted.appointmentChannelId = visit?.appointmentChannel?.id;
  return converted;
};
